module.exports = __webpack_public_path__ + "f70c049b54eee5a63b5f8ed9f585899b.pdf";